<template>
  <div class="main">
    <report-top> </report-top>
    <div id="formTable">
      <div id="formTable">
        <div class="formTableItem">
          <p class="label">时间范围</p>
          <start-end ref="startEnd" timeModel="2,3,0" :datetime='true'></start-end>
        </div>
        <div class="formTableItem">
          <p class="label">选择车辆</p>
          <selecAlotCCar
            ref="selecAlotCCar"
            @deviceIdList="searchItem.deviceIdList = $event"
          ></selecAlotCCar>
        </div>
        <div class="formTableItem">
          <p class="label">停车时长(大于)</p>
          <InputNumber v-model="searchItem.duration"></InputNumber>/分
        </div>
        <div class="formTableItem">
          <Button @click="exportAll" class="chaxun">导出</Button>
          <Button @click="chaxun" type="primary" class="chaxun"
            >查询</Button
          >
        </div>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)"
    >
      <template slot-scope="{ row, index }" slot="pakAdd">
        <a :title="row.pakAdd" @click="openMap(row)">{{ row.pakAdd }}</a>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <ly-map ref="lymap"></ly-map>
  </div>
</template>
<script>
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "车牌号",
          key: "carNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "设备号",
          key: "deviceNo",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "驾驶员",
          key: "driverName",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "停车地点",
          slot: "pakAdd",
          minWidth: 200,
          maxWidth: 300,
        },
        {
          title: "标注点",
          key: "pakRulePointName",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "停车里程",
          key: "pakMileage",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "停车时长/分",
          key: "duration",
          minWidth: 100,
          maxWidth: 200,
        },

        {
          title: "开始时间",
          key: "startTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.startTime));
          },
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "结束时间",
          key: "endTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.endTime));
          },
          minWidth: 130,
          maxWidth: 200,
        },
      ],
      tableData: [],
      total: 0,
      searchItem: {
        deviceIdList: [],
        driverIdList: [],
        endTime: 0,
        startTime: 0,
        pageSize: 50,
        pageNumber: 1,
        duration:0
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.report + "/parking/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          this.total = res.data.data.total;
          var data = res.data.data.dataList;
          console.log(data);
          this.tableData = data;
          //this.jiexis
        }
      });
    },
    exportAll() {
      var params = [
        {
          name: "deviceIdList",
          value: this.searchItem.deviceIdList,
        },
        {
          name: "driverIdList",
          value: this.searchItem.driverIdList,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(this.axios.report + "/parking/export", params);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    chaxun() {
      this.searchItem.startTime = this.$refs.startEnd.getTimeObj().start;
      this.searchItem.endTime = this.$refs.startEnd.getTimeObj().end;
      this.getList();
    },
    search() {
      this.reset();
      this.getList();
    },
    openMap(v) {
      var obj = {
        address: v.pakAdd,
        lng: v.pakX,
        lat: v.pakY,
      };
      this.$refs.lymap.open(obj);
    },
    jiexis(row, index) {
      //row.address = 12345677;
      var h = this.tableData;
      var pointList = [];
      for (let i = 0; i < h.length; i++) {
        pointList.push({ x: h[i].pakX, y: h[i].pakY })

      }
      this.utils.jiexi(pointList).then((data) => {
        console.log(654,data)
        for (let i = 0; i < data.length; i++) {
          h[i].startAdd = data[i].address;
        }
      });
      //console.log(this.historyData[1].address);
      //console.log(this.historyData[2].address);
    },
  },
  mounted() {
    this.chaxun();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// ../common/src/components/report/parking.vue